import { combineReducers } from 'redux';
import coverage from './steps/Coverage/state';
import basicInfo from './steps/BasicInfo/state';
import destinations from './steps/Destinations/state';
import applicants from './steps/Applicants/state';
import review from './steps/Review/state';
import independencePayment from './steps/Payment/IndependencePayment/state';

export default combineReducers({
  coverage,
  basicInfo,
  destinations,
  applicants,
  review,
  independencePayment
});
